import { useState } from 'react';
import { useLang } from '../context/LangContext';
import { UI } from '../i18n/translations';

const EMPTY = { firstName: '', lastName: '', email: '', phone: '', service: '', message: '' };

export default function ConsultationForm({ services = [] }) {
  const [form, setForm]       = useState(EMPTY);
  const [status, setStatus]   = useState('idle');
  const [errMsg, setErrMsg]   = useState('');
  const { lang } = useLang();
  const t = UI[lang];

  const set = field => e => setForm(p => ({ ...p, [field]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');
    setErrMsg('');

    const from_name = `${form.firstName} ${form.lastName}`.trim();

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: '9eb7c668-043b-48d0-8db9-4946ce35bc47',
          subject: `📅 New Consultation Request – ${form.service}`,
          from_name: 'AMKO Agency Website',
          replyto: form.email,
          botcheck: '',
          'Full Name':  from_name,
          'Email':      form.email,
          'Phone':      form.phone,
          'Service':    form.service,
          'Message':    form.message,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus('success');
        setForm(EMPTY);
      } else {
        setErrMsg(data.message || 'Something went wrong. Please try again.');
        setStatus('error');
      }
    } catch {
      setErrMsg('Network error. Please check your connection and try again.');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="cf-success">
        <div className="cf-success-icon">✅</div>
        <h3>{t.cfSuccess}</h3>
        <p>{t.cfSuccessMsg}</p>
        <button className="btn-primary" onClick={() => setStatus('idle')}>{t.cfSendAnother}</button>
      </div>
    );
  }

  const sending = status === 'sending';

  return (
    <form onSubmit={handleSubmit} className="form">
      <div className="form-row">
        <input placeholder={t.cfFirstName} required value={form.firstName} onChange={set('firstName')} disabled={sending} />
        <input placeholder={t.cfLastName}  required value={form.lastName}  onChange={set('lastName')}  disabled={sending} />
      </div>
      <input type="email" placeholder={t.cfEmail} required value={form.email}   onChange={set('email')}   disabled={sending} />
      <input type="tel"   placeholder={t.cfPhone} required value={form.phone}   onChange={set('phone')}   disabled={sending} />
      <select required value={form.service} onChange={set('service')} disabled={sending}>
        <option value="">{t.cfService}</option>
        {services.map(s => <option key={s} value={s}>{s}</option>)}
      </select>
      <textarea rows={4} placeholder={t.cfMessage} required value={form.message} onChange={set('message')} disabled={sending} />
      <input type="checkbox" name="botcheck" style={{ display: 'none' }} />
      <button type="submit" className="btn-primary" disabled={sending}>
        {sending ? t.cfSending : t.cfSend}
      </button>
      {status === 'error' && <p className="cf-error">{errMsg}</p>}
      <p className="book-email-note">{t.cfNote}</p>
    </form>
  );
}
